import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import { ExternalSystem } from '../../../components/SystemSettings/ConfigurationApi/configurationApi.types';
import usePermission, { UserPermission } from '../../../hooks/usePermission';
import { useStyles } from '../ExaminerCreate/ExaminerCreate.styles';
import { ImportExaminersFromExternalSystem } from './Modals/ImportExaminersFromExternalSystem.component';
import { ImportExaminersFromFile } from './Modals/ImportExaminersFromFile.components';

type importType = 'File' | ExternalSystem;

export const ImportExaminers: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [menuAnchor, setMenuAnchor] = useState<SVGSVGElement | HTMLElement>();
  const [importModalOpen, setImportModalOpen] = useState<importType>();

  const hasAdminExaminerCreate = usePermission(UserPermission.AdminExaminerCreate);
  const hasAdminOkeExaminerCreate = usePermission(UserPermission.AdminOkeExaminerCreate);

  const handleMenuItem = (type: importType) => {
    setMenuAnchor(undefined);
    setImportModalOpen(type);
  };

  const hideModal = () => {
    setImportModalOpen(undefined);
  };

  return (
    <>
      <ButtonOne
        style={{ backgroundColor: '#3560FF' }}
        className={classes.addUserButton}
        variant="contained"
        color="secondary"
        startIcon={<UploadFileIcon />}
        onClick={(e) => setMenuAnchor(e.currentTarget)}
      >
        {t('examiners:header.importExaminersButton')}
      </ButtonOne>
      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(undefined)}>
        <MenuItem disableRipple onClick={() => handleMenuItem('File')}>
          <ListItemIcon>
            <IosShareOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Import z pliku
        </MenuItem>
        {(hasAdminExaminerCreate || hasAdminOkeExaminerCreate) && [
          <MenuItem disableRipple key="sioeo" onClick={() => handleMenuItem('Sioeo')}>
            <ListItemIcon></ListItemIcon>
            {`Import z ${t('global:shortNames.SIOEO')}`}
          </MenuItem>,
          <MenuItem disableRipple key="sioepkz" onClick={() => handleMenuItem('Sioepkz')}>
            <ListItemIcon></ListItemIcon>
            Import z SIOEPKZ
          </MenuItem>,
        ]}
      </Menu>
      {importModalOpen === 'File' && (
        <ImportExaminersFromFile
          permissions={{ hasAdminExaminerCreate, hasAdminOkeExaminerCreate }}
          onClose={hideModal}
        />
      )}
      {(importModalOpen === 'Sioeo' || importModalOpen === 'Sioepkz') && (
        <ImportExaminersFromExternalSystem
          system={importModalOpen}
          permissions={{ hasAdminExaminerCreate, hasAdminOkeExaminerCreate }}
          onClose={hideModal}
        />
      )}
    </>
  );
};
